export default {
    CUSTOM_PIN: 'custom_pin',
    USER_SAVED_LOCATION: 'user_saved_location',
    PROJECT_DEFINITION_LOCATION: 'project_definition_location',
    SEARCH_RESULT: 'search_result',
    GEO_JSON: 'geo_json',
    LIBRARY_LAYER_FEATURE: 'library_layer_feature',
};
